<template>
    <div id="footer">
        <div class="float-right-sidebar">
            <div class="float-sidebar">
                <div class="hidden-sm-and-down">
                    <div class="float-sidebar-item helps"> <!-- @mouseenter="enter" @mouseleave="leave" --> 
                        <a href="javascript:void(0)" rel="insurance" class="fs_icon-wrapper help">
                            <i class='el-icon-headset'></i>
                        </a>
                        <div id="tooltip-customer-div" class="float-sidebar-tooltip tooltip-customer display-none help">
                            <span>Hi,有什么问题可以帮您？</span>
                                                        <button class="tooltip-customer-button">
                                                            <!--立即咨询-->
                                                            稍后再试，建设中...
                                                        </button>
							<!-- <span><span>免费售前咨询</span><br /><span>获取企业级解决方案</span></span>
                            <img src="@/static/img/home/kefu.png" /> -->
                        </div>
                    </div>
                    <div class="float-sidebar-item cursor-pointer helps"><!-- @mouseenter="enter" @mouseleave="leave" --> 
                        <a href="javascript:void(0)" rel="insurance2" class="fs_icon-wrapper help"><i
                                class='el-icon-phone-outline'></i></a>
                        <div class="float-sidebar-tooltip tooltip-chat display-none help">
                            <div class="mb-20">
                                <p class="tooltip-chat-text">咨询电话：</p>
                                <p class="tooltip-chat-number">400-666-1916</p>
                            </div>
                            <div class="mb-20">
                                <p class="tooltip-chat-text">咨询邮箱</p>
                                <p class="tooltip-chat-email">support@createc.cn</p>
                            </div>
                            <div class="clickable">
                                <p class="tooltip-chat-text">建议反馈</p>
                                <p class="tooltip-chat-intro">倾听您宝贵的建议与反馈</p>
                            </div>
                        </div>
                    </div>
                    <div class="float-sidebar-item cursor-pointer billsubmit">
                        <a href="javascript:void(0)" rel="noopener noreferrer" class="fs_icon-wrapper bill"><i
                                class='el-icon-edit-outline'></i>
                        </a>
                        <a href="https://18533113852.eshouhou.cn" target="_blank" rel="noopener noreferrer"
                            class="float-sidebar-tooltip tooltip-feedback clickable display-none bill">
                            售后工单
                            <button class="tooltip-customer-button">
                                前往申报
                            </button>
                        </a>
                    </div>
                </div>
            </div>
            <!-- vue 回到顶部 -->
            <el-backtop 
            :bottom="100" 
            :visibility-height="50" 
            style="width:48px;height:48px;border-radius:0px;color:blue;background:white;right: 16px;"
            >
            <i class="el-icon-arrow-up"></i>
        </el-backtop>
        </div>

        <div class="footer-top">
            <div>

                <el-row class="el-row">

                    <el-col :span="7" class="footer-contact">
                        <h4>服务热线： 400-666-1916</h4>
                        <p>
                            <strong>国内：</strong> 0311-82220136<br>
                            <strong>外贸：</strong> 0311-83056195<br>
                            <strong>地址：</strong> 石家庄市鹿泉区槐安西路科瀛·智创谷23座 <br>
                            <strong>Email：</strong> webmaster@createc.cn<br>
                            <strong>邮 编：</strong> 050091<br>
                        </p>
                    </el-col>
                    <el-col :span="4" class="footer-links">
                        <h4>关于我们</h4>
                        <ul>
                            <li><i class="bx bx-chevron-right"></i> <a href="/about">企业简介</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="/history">发展历程</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="/honor">资质荣誉</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="/news">新闻动态</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="/job">人才招聘</a></li>
                        </ul>
                    </el-col>
                    <el-col :span="3" class="footer-links">
                        <h4>服务与支持</h4>
                        <ul>
                            <li><i class="bx bx-chevron-right"></i> <a href="/product/category">产品中心</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="/solution">行业方案</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="/case">客户案例</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="https://18533113852.eshouhou.cn" target="_blank">维修工单</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="/contact">联系我们</a></li>
                        </ul>
                    </el-col>
                    <el-col :span="3" class="footer-links">
                        <h4>常用链接</h4>
                        <ul>
                            <!-- <li><i class="bx bx-chevron-right"></i> <a href="http://39.105.114.156:8000/" target="_blank">在线商城</a></li> -->
                            <li><i class="bx bx-chevron-right"></i> <a href="https://createc.taobao.com/" target="_blank">淘宝店铺</a></li>
                            <li><i class="bx bx-chevron-right"></i> <a href="https://kedayiqi.1688.com/" target="_blank">阿里店铺</a></li>
							<li><i class="bx bx-chevron-right"></i> <a href="http://old.createc.cn/" target="_blank">旧版官网</a></li>
                        </ul>
                    </el-col>
                    <el-col :span="7" class="footer-info">
                        <h4>关注科瑞达</h4>
						<div class="social-links">
							<img src="@/static/img/qrcode/wx.png" width="110px" height="110px" />
							<div style="text-align:center">官方公众号</div>
						</div>
						<div class="social-links">
							<img src="@/static/img/qrcode/rlapp.png" width="110px" height="110px" />
							<div style="text-align:center">瑞联云APP</div>
						</div>
						<div class="social-links">
							<img src="@/static/img/qrcode/micapp.png" width="110px" height="110px" />
							<div style="text-align:center">产品选型</div>
						</div>
                    </el-col>
                </el-row>

            </div>
        </div>

        <div class="container">
			<div class="links">
				<div class="name">友情链接：</div>
				<div><a href="http://www.cima.org.cn/" target="_blank">中国仪器仪表协会</a></div>
				<div><a href="http://www.eastseapump.com/" target="_blank">管道泵</a></div>
				<div><a href="https://www.whmoen.com/" target="_blank">串联谐振</a></div>
				<div><a href="http://www.huoyumi.com/" target="_blank">磁性液位计</a></div>
				<div><a href="http://www.china-suke.com/" target="_blank">电磁流量计</a></div>
			</div>
            <div class="copyright">
                &copy;版权所有 河北科瑞达仪器科技股份有限公司 最终解释权归本公司所有
            </div>
			<div class="credits">
                <el-link href="http://beian.miit.gov.cn" target="_blank">冀ICP备11016789号-15</el-link>&nbsp;<a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank"><img src="@/static/img/public/wxbacx.png" /></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    methods: {
        enter(e) {
            e.currentTarget.firstElementChild.className ="fs_icon-wrapper enter-mouse";
            e.currentTarget.firstElementChild.nextElementSibling.className ="float-sidebar-tooltip tooltip-customer display-inline";
        },
         leave(e) {
            e.currentTarget.firstElementChild.className ="fs_icon-wrapper leave-mouse";
            e.currentTarget.firstElementChild.nextElementSibling.className ="float-sidebar-tooltip tooltip-customer display-none";
        },
    }
}
</script>
<style lang="css" scoped>
.container {
    width: 1280px;
    margin: 20px auto 20px auto
}
.enter-mouse{
    color: #ffffff;
    background-color: #0284db;
}
.leave-mouse{
    color: #000000;
    background-color: #fdfdfd;
}
.display-inline{
    display: inline;
}
.display-none{
    display: none;
}

/* .back-top{
    background-color: #fff;
    box-shadow: 0 0 6px 0 rgb(0 0 0 / 10%);
    border: 1px solid rgba(220,223,230,.1);
    width: 42px;
    height: 42px;
    font-size: 20px;
    color: #004baa;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    position: fixed;
    right: 16px;
    bottom: 100px;
} */
/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
#footer {
    background: #05579e;
    padding: 0px 0 20px 0;
    color: #fff;
    font-size: 14px;
}

#footer .footer-top {
    background: #065fad;
    padding: 50px 0 30px 0;
    
}
#footer .footer-top >div{
        width:1280px;
        margin-left: auto;
        margin-right: auto;
    }
#footer .footer-top .el-row{
    margin:0 auto
}

#footer .footer-top .footer-info {
    float: left;
    margin-bottom: 30px;
}

#footer .footer-top .footer-info h3 {
    font-size: 18px;
    margin: 0 0 20px 0;
    padding: 2px 0 2px 0;
    line-height: 1;
    font-weight: 700;
}

#footer .footer-top .footer-info p {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 0;
    font-family: "Raleway", sans-serif;
    color: #fff;
}

#footer .footer-top .social-links {
    float: left;
    margin-left: 10px;
}

#footer .footer-top .social-links a {
    font-size: 16px;
    display: inline-block;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    line-height: 1;
    padding: 10px 0;
    margin-right: 4px;
    border-radius: 50%;
    text-align: center;
    width: 36px;
    height: 36px;
    transition: 0.3s;
}


#footer .footer-top .social-links a:hover {
    background: #f6b024;
    color: #fff;
    text-decoration: none;
}

#footer .footer-top h4 {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    text-transform: uppercase;
    position: relative;
    padding-bottom: 12px;
}

#footer .footer-top .footer-links {
    margin-bottom: 30px;
}

#footer .footer-top .footer-links ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

#footer .footer-top .footer-links ul i {
    padding-right: 2px;
    color: #5db1f9;
    font-size: 18px;
    line-height: 1;
}

#footer .footer-top .footer-links ul li {
    padding: 10px 0;
    display: flex;
    align-items: center;
}

#footer .footer-top .footer-links ul li:first-child {
    padding-top: 0;
}

#footer .footer-top .footer-links ul a {
    color: rgba(255, 255, 255, 0.75);
    transition: 0.3s;
    display: inline-block;
    line-height: 1;
}

#footer .footer-top .footer-links ul a:hover {
    color: #fff;
}

#footer .footer-top .footer-contact {
    margin-bottom: 30px;
}

#footer .footer-top .footer-contact p {
    line-height: 26px;
}

#footer .copyright {
    text-align: center;

}

#footer .credits {
    padding-top: 5px;
    text-align: center;
    font-size: 13px;
    color: #fff;
}

.credits img {
	vertical-align: middle;
	/* padding-bottom: 6px; */
}

.billsubmit{
    text-align: right;
    background: transparent;
}

.billsubmit:hover .bill, .helps:hover .help{
    display: block;
}
.hidden-sm-and-down>div>:first-child{
	box-shadow: 0 8px 16px -2px rgba(0,0,0,.1);
}
.float-sidebar-item {
	box-shadow: 0 0 0 0 transparent !important;
}

.float-sidebar-tooltip.help{
    display: none;
    width: 180px !important;
    left: -220px !important;
    padding: 18px 20px !important;
}
.bill{
    display: none;
    left: -190px !important
}
/*--------------------------------------------------------------
# float-right-sidebar
--------------------------------------------------------------*/
.cursor-pointer {
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
}

.float-right-sidebar {
    position: fixed;
    right: 16px;
    bottom: 200px;
    z-index: 998
}

.float-sidebar-item {
    width: 40px;
    height: 40px;
    background: #004baa;
    color: #fff;
    box-shadow: 0 8px 16px -2px rgba(0, 0, 0, .1);
    line-height: 40px;
    text-align: center;
    margin-bottom: 6px;
    position: relative
}

.fs_icon-wrapper {
    /* background: inherit; 
    color: inherit;*/
    background: #fff;
    display: inline-block;
    width: 100%;
    height: 100%;
    font-size: 28px;
}
.fs_icon-wrapper.bill{
    width: 48px;
    background: #fff;
}

.float-sidebar-tooltip {
    position: absolute;
    top: 0;
    background: #fff;
    color: #000;
    box-shadow: 0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05);
    padding: 24px;
    text-align: left
}

.float-sidebar-tooltip:after {
    content: "";
    position: absolute;
    top: 8px;
    right: -10px;
    border-color: #fff transparent transparent #fff;
    border-style: solid;
    border-width: 5px;
    filter: drop-shadow(0 0 2px rgba(16, 0, 0, .1))
}

.float-sidebar-tooltip.tooltip-customer {
    left: -265px;
    width: 209px;
    font-size: 14px;
    line-height: 20px;
    padding: 24px
}

.float-sidebar-tooltip .tooltip-customer-button {
    border: 1px solid #0000ff;
    background-color: #0000ff;
    padding: 2px 12px;
    color: #fff;
    font-size: 14px;
    line-height: 22px;
    /* margin-top: 28px; */
    cursor: pointer
}

.float-sidebar-tooltip.tooltip-chat {
    left: -265px;
    width: 209px
}

.float-sidebar-tooltip .tooltip-chat-email,
.float-sidebar-tooltip .tooltip-chat-text {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0
}

.float-sidebar-tooltip .tooltip-chat-number {
    font-size: 20px;
    line-height: 28px;
    color: #004baa
}

.float-sidebar-tooltip .tooltip-chat-intro {
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 0
}

.float-sidebar-tooltip.tooltip-feedback {
    left: -152px;
    width: 142px;
    font-size: 14px;
    line-height: 20px;
    padding: 14px 24px
}

@media (min-width: 768px) {
    .float-sidebar-item {
        width: 48px;
        height: 48px;
        background: transparent;
        color: #333;
        line-height: 48px;
        margin-bottom: 2px;
        padding-left: 10px;
    }

    .float-sidebar-item.active {
        background: #004baa;
        color: #fff
    }
}

.float-sidebar__phone-drawer {
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 16px
}

.float-sidebar__phone-drawer .el-drawer__body {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 6px
}

.float-sidebar__phone {
    background-color: #fff;
    margin-bottom: 10px;
    padding: 12px 16px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700
}

.float-sidebar__phone-number {
    font-size: 20px;
    color: #004baa;
    line-height: 28px;
    font-weight: 400
}

.float-sidebar__phone-btn {
    width: 100%;
    height: 42px;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    margin-bottom: 10px
}

.float-sidebar__phone-btn.blue {
    background-color: #004baa;
    color: #fff
}

.float-sidebar__phone-btn.white {
    background-color: #fff;
    color: #666
}

@media only screen and (max-width: 767px) {
    .hidden-xs-only {
        display: none !important
    }
}

@media only screen and (min-width: 768px) {
    .hidden-sm-and-up {
        display: none !important
    }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
    .hidden-sm-only {
        display: none !important
    }
}

@media only screen and (max-width: 991px) {
    .hidden-sm-and-down {
        display: none !important
    }
}

@media only screen and (min-width: 992px) {
    .hidden-md-and-up {
        display: none !important
    }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .hidden-md-only {
        display: none !important
    }
}

@media only screen and (max-width: 1199px) {
    .hidden-md-and-down {
        display: none !important
    }
}

@media only screen and (min-width: 1200px) {
    .hidden-lg-and-up {
        display: none !important
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1919px) {
    .hidden-lg-only {
        display: none !important
    }
}

@media only screen and (max-width: 1919px) {
    .hidden-lg-and-down {
        display: none !important
    }
}

@media only screen and (min-width: 1920px) {
    .hidden-xl-only {
        display: none !important
    }
}

#footer .container{
	margin-bottom: 10px;
}
.container .links{
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 20px 0 25px;
	>div{
		margin-right: 15px;
	}
	.name{
		margin-right: 0;
	}
}
.container .links a{
	color: #fff
}
::v-deep .el-link.el-link--default{
    color: #ffffff;
}
::v-deep .el-link.is-underline:hover:after{
    border-bottom: 1px solid #ffffff;
}
/* #tooltip-customer-div >:first-child{
	display: block;
	width: 100%;
	text-align: center;
	:first-child{
		font-size: 18px;
		color: #2E2E2E;
		font-weight: bold;
	}
	:last-child{
		font-size: 15px;
		line-height: 30px;
		color: #6B6B6B;
		font-weight: bold;
	}
}
#tooltip-customer-div{
	width: 160px !important;
	text-align: center;
}
#tooltip-customer-div{
	left: -200px !important;
	padding-bottom: 10px !important;
}
#tooltip-customer-div img{
	margin-top: 5px;
	width: 160px;
	height: 160px;
} */
</style>